export const ROUTE_PROGRESS_BAR_ID = 'route-progress-bar';
export const FULL_PAGE_RELOAD_PROGRESS_TIMEOUT_MS = 15_000;
